export { FaqAccordion } from './FaqAccordion'
